import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import ResponsiveMixin from 'react-responsive-mixin'
import { injectIntl } from 'react-intl'
import messages from './messages'

class ChartTypeFilter extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.select = React.createRef()
    this.state = {
      activeButton: 'evolutionAbsolute',
      responsive: true
    }
  }

	handleClick = event => {
	  if (event) {
	    this.props.fn(event.target.value)
	    this.setState({ activeButton: event.target.value })
	  } else {
	    this.props.fn('evolutionAbsolute')
	  }
	}

	componentDidMount() {
	  ResponsiveMixin.media({ minWidth: 992 }, () => this.setState({ responsive: false }))
	  ResponsiveMixin.media({ maxWidth: 991 }, () => this.setState({ responsive: true }))
	  this.handleClick()
	}

	renderIfAllOK() {
	  let renderingComponent = null
	  let buttonGroup = (
	    <React.Fragment>
	      <Button value="evolutionAbsolute" onClick={this.handleClick} active={this.state.activeButton === 'evolutionAbsolute' ? true : false}>
	        {this.formatMessage(messages.absoluteValuesEvolution)}
	      </Button>
	      {/* <Button value="evolutionRanking" onClick={this.handleClick} active={this.state.activeButton === 'evolutionRanking' ? true : false}>
					Evolución posición en el ranking
	      </Button>
	      <Button value="dispersion" onClick={this.handleClick} active={this.state.activeButton === 'dispersion' ? true : false}>
					Dispersión
	      </Button> */}
	      <Button value="map" onClick={this.handleClick} active={this.state.activeButton === 'map' ? true : false}>
	        {this.formatMessage(messages.map)}
	      </Button>
	    </React.Fragment>
	  )

	  renderingComponent = <div>{buttonGroup}</div>
	  return renderingComponent
	}

	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(ChartTypeFilter)



// WEBPACK FOOTER //
// ./src/modules/Filters/ChartTypeFilter/ChartTypeFilter.jsx